import { uniqBy } from 'es-toolkit';

import type { SaversCarrierResponse } from './api';

export const normalizeAllSaversCarriers = (list: SaversCarrierResponse) => {
  if (!list) {
    return [];
  }

  const uniqueCarriers = uniqBy(list, ({ carrierKey }) => carrierKey);
  return uniqueCarriers.map((row) => ({
    label: row.carrierName,
    value: row.carrierKey,
  }));
};
